module.exports = __webpack_public_path__ + "img/header-bg.6839bd78.png";